var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4 tn-home"},[_vm._v(" 열쩡테니스 "),_c('h1',[_vm._v(_vm._s(_vm.recentMile.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }